import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import CreateRequest from "./CreateRequest";

const CreateRequestLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Create Request" />
      <CreateRequest />
    </MasterLayout>
  );
};

export default CreateRequestLayout;
